export * from './app-sidebar.component';



// WEBPACK FOOTER //
// ./src/app/shared/app-sidebar/index.ts